module.exports = __webpack_public_path__ + "static/media/carousel3.3a0fedf0.png";